export default {
  cashBook: 0, // Báo cáo không có đối tượng
  cashBookObject: 1, // Báo cáo có đối tượng
};
